/* ULTREIA — personalizador de variantes.
   Interpreta las variantes que YA existen en Shopify y las presenta
   como una app de cafetería. No crea, borra, renombra ni cambia
   precios ni ids: solo lee /products/{handle}.js y mapea la
   selección del cliente al id real de la variante.
   - Muestra selector solo si hay una opción con 2+ valores.
   - Combinación inexistente o agotada → no se puede agregar.
   - Precio y disponibilidad salen de la variante encontrada. */
(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'UYU';
      return new Intl.NumberFormat('es-UY', { style: 'currency', currency: cur }).format(amount);
    } catch (e) { return '$' + amount.toFixed(2); }
  }

  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) cache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function optionNames(p) {
    return (p.options || []).map(function (o) { return (typeof o === 'string') ? o : o.name; });
  }
  function distinctValues(p, i) {
    var out = [];
    p.variants.forEach(function (v) { if (out.indexOf(v.options[i]) === -1) out.push(v.options[i]); });
    return out;
  }
  function needsPicker(p) {
    if (!p || !p.variants || p.variants.length < 2) return false;
    return optionNames(p).some(function (n, i) { return distinctValues(p, i).length >= 2; });
  }
  function findVariant(p, sel) {
    return p.variants.find(function (v) {
      return sel.every(function (s, i) { return s != null && v.options[i] === s; });
    });
  }
  function valueMatches(p, i, val, sel, requireAvailable) {
    return p.variants.some(function (v) {
      if (v.options[i] !== val) return false;
      if (requireAvailable && !v.available) return false;
      return sel.every(function (s, j) { return j === i || s == null || v.options[j] === s; });
    });
  }

  var overlay, panel;
  function buildOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'u-perso-overlay';
    overlay.innerHTML = '<div class="u-perso" role="dialog" aria-modal="true"></div>';
    panel = overlay.querySelector('.u-perso');
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) close(); });
    document.body.appendChild(overlay);
  }
  function close() { if (overlay) overlay.classList.remove('is-open'); document.documentElement.style.overflow = ''; }

  function open(p) {
    buildOverlay();
    var names = optionNames(p);
    var sel = names.map(function (n, i) { var vals = distinctValues(p, i); return vals.length === 1 ? vals[0] : null; });
    var qty = 1;

    function render() {
      var groups = names.map(function (name, i) {
        var vals = distinctValues(p, i);
        if (vals.length < 2) return '';
        var chips = vals.map(function (val) {
          var avail = valueMatches(p, i, val, sel, true);
          var active = sel[i] === val;
          var cls = 'u-perso__chip' + (active ? ' is-active' : '') + (avail ? '' : ' is-off');
          return '<button type="button" class="' + cls + '"' + (avail ? '' : ' aria-disabled="true"') +
                 ' data-oi="' + i + '" data-ov="' + encodeURIComponent(val) + '">' + val +
                 (avail ? '' : ' <span class="u-perso__na">agotado</span>') + '</button>';
        }).join('');
        return '<div class="u-perso__group"><h4 class="u-perso__glabel">' + name + '</h4><div class="u-perso__chips">' + chips + '</div></div>';
      }).join('');

      var variant = findVariant(p, sel);
      var priceCents = variant ? variant.price : p.price;
      var canAdd = !!(variant && variant.available);
      var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';

      panel.innerHTML =
        '<button type="button" class="u-perso__close" aria-label="Cerrar">×</button>' +
        (img ? '<div class="u-perso__media"><img src="' + img + '" alt=""></div>' : '') +
        '<div class="u-perso__body">' +
          '<h3 class="u-perso__title">' + p.title + '</h3>' + groups +
          '<div class="u-perso__foot">' +
            '<div class="u-perso__qty"><button type="button" class="u-perso__qtybtn" data-q="-1">−</button><span class="u-perso__qtyval">' + qty + '</span><button type="button" class="u-perso__qtybtn" data-q="1">+</button></div>' +
            '<button type="button" class="u-perso__add' + (canAdd ? '' : ' is-disabled') + '"' + (canAdd ? '' : ' disabled') + '>' +
              '<span>' + (canAdd ? 'Agregar al carrito' : (variant ? 'Agotado' : 'Elegí una opción')) + '</span>' +
              '<span class="u-perso__price">' + formatMoney(priceCents) + '</span>' +
            '</button>' +
          '</div>' +
        '</div>';

      panel.querySelector('.u-perso__close').onclick = close;
      panel.querySelectorAll('.u-perso__chip').forEach(function (b) {
        b.onclick = function () {
          if (b.getAttribute('aria-disabled')) return;
          var i = +b.dataset.oi, val = decodeURIComponent(b.dataset.ov);
          sel[i] = (sel[i] === val) ? null : val;
          render();
        };
      });
      panel.querySelectorAll('.u-perso__qtybtn').forEach(function (b) {
        b.onclick = function () { qty = Math.max(1, qty + (+b.dataset.q)); render(); };
      });
      var add = panel.querySelector('.u-perso__add');
      if (add) add.onclick = function () {
        var v = findVariant(p, sel);
        if (!v || !v.available) return;
        addToCart(v.id, qty, add);
      };
    }

    render();
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function addToCart(id, qty, btn) {
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) { return r.json(); })
      .then(function () { btn.classList.remove('is-loading'); close(); refreshAndOpenCart(); })
      .catch(function () { btn.classList.remove('is-loading'); });
  }

  function refreshAndOpenCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var drawer = document.querySelector('cart-drawer');
    fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (data) {
      if (data['cart-icon-bubble']) { var b = document.getElementById('cart-icon-bubble'); var f = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html').body.firstElementChild; if (b && f) b.innerHTML = f.innerHTML; }
      if (drawer && data['cart-drawer']) {
        var fresh = new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open(); else drawer.setAttribute('open', '');
      } else {
        var link = document.querySelector('#cart-icon-bubble, .header__icon--cart');
        if (link) link.click(); else window.location = '/cart';
      }
    }).catch(function () { var link = document.querySelector('.header__icon--cart'); if (link) link.click(); else window.location = '/cart'; });
  }

  function handleFromCard(el) {
    var card = el.closest('.card-wrapper, .card, .grid__item, li, .product');
    var a = card && card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function pageHandle() { var m = location.pathname.match(/\/products\/([^/?#]+)/); return m ? m[1] : null; }

  function enhance() {
    document.querySelectorAll('.quick-add__submit, .quick-add button, product-form button[name="add"]').forEach(function (btn) {
      if (btn.dataset.uPerso) return;
      var onCard = !!btn.closest('.card-wrapper, .grid__item');
      var handle = onCard ? handleFromCard(btn) : pageHandle();
      if (!handle) return;
      btn.dataset.uPerso = 'x';
      getProduct(handle).then(function (p) {
        if (!needsPicker(p)) return;
        var span = btn.querySelector('span:not(.visually-hidden)') || btn;
        span.textContent = 'Personalizar';
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
          getProduct(handle).then(function (pp) { if (pp) open(pp); });
        }, true);
      });
    });

    var ph = pageHandle();
    if (ph && !document.body.dataset.uPersoPage) {
      document.body.dataset.uPersoPage = 'x';
      getProduct(ph).then(function (p) {
        if (!needsPicker(p)) return;
        document.querySelectorAll('variant-selects, variant-radios').forEach(function (el) { el.style.display = 'none'; });
        var buy = document.querySelector('.product-form__buttons');
        if (buy && !document.querySelector('.u-perso-open')) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'button button--full-width u-perso-open';
          b.textContent = 'Personalizar';
          b.addEventListener('click', function () { open(p); });
          buy.parentNode.insertBefore(b, buy);
          buy.style.display = 'none';
        }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
  new MutationObserver(function () { enhance(); }).observe(document.body, { childList: true, subtree: true });
})();
